import React from 'react';

type TextHighlightedProps = {
  text: string;
  highlight?: string;
};

export const TextHighlighted = ({ text, highlight }: TextHighlightedProps) => {
  if (!highlight) return <span>{text}</span>;

  const searchText = highlight
    ?.split(' ')
    // escape special chars
    .map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');

  const replaceRegex = new RegExp(`(${searchText})`, 'gi');

  const matches = text.split(replaceRegex);

  return (
    <span style={{ lineBreak: 'auto' }}>
      {matches.map((part, index) =>
        // use replaceRegex to verify if the part is a match
        replaceRegex.test(part) ? <mark key={index}>{part}</mark> : part
      )}
    </span>
  );
};
